import React, { useState, useEffect } from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import { updateLanguage } from 'store/app';

const images = [
  {
    src: 'images/image01.png',
    larger: true
  },
  {
    src: 'images/image02.png',
    larger: false
  },
  {
    src: 'images/image03.png',
    larger: true
  },
  {
    src: 'images/image04.png',
    larger: false
  },
  {
    src: 'images/image05.png',
    larger: true
  }
]

const Intro = () => {
  const { i18n, t } = useTranslation();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isClicked, setIsClicked] = useState(false);

  const { language } = useSelector((state) => state.app);

  const handleClick = () => {
    setIsClicked(true);

    // Navigate after animation completes
    setTimeout(() => {
      navigate('/login'); // Change this to your target route
    }, 500);
  };

  const changeLanguage = (lang) => {
    dispatch(updateLanguage(lang));
    i18n.changeLanguage(lang);
  }

  useEffect(() => {
    changeLanguage(language);
    // eslint-disable-next-line
  }, [])

  return (
    <div className="relative h-screen w-full overflow-hidden bg-gray-100 flex flex-col justify-center items-center">
      <div className="flex flex-col items-center gap-2 rotate-[22deg] h-[110vh] -mt-12 opacity-20 absolute left-1/2 -translate-x-20 pointer-events-none">
        {images.map((item, index) =>
          <img
            key={index}
            alt={'image' + index}
            src={item.src}
            className={cn(
              'h-auto rounded-lg',
              {
                'w-[175px]': !item.larger,
                'w-[200px]': item.larger
              }
            )}
          />
        )}
      </div>

      <div className="flex flex-col justify-center items-center gap-10 h-full z-10">
        <img
          alt="library"
          src="library-logo.svg"
        />
        <motion.div
          className="flex justify-center items-center h-28 w-28 rounded-full bg-dark shadow cursor-pointer"
          whileTap={{ scale: 0.9 }}
          animate={
            isClicked
              ? {
                scale: [1, 1.2, 0],
                opacity: [1, 1, 0],
                transition: { duration: 0.5 }
              }
              : {
                scale: [1, 1.1, 1],
                boxShadow: [
                  "0px 0px 0px rgba(0,0,0,0.2)",
                  "0px 0px 20px rgba(0,0,0,0.4)",
                  "0px 0px 0px rgba(0,0,0,0.2)"
                ],
                transition: {
                  duration: 2,
                  repeat: Infinity,
                  repeatType: "reverse"
                }
              }
          }
          onClick={handleClick}
        >
          <span className="text-white text-lg uppercase font-medium">
            {t('general.start')}
          </span>
        </motion.div>
      </div>
      <div className="flex flex-col gap-1 py-3 justify-center items-center">
        <span
          className="text-base font-semibold"
          dangerouslySetInnerHTML={{ __html: t('footer.text') }}
        />
        <div className="flex items-center gap-1">
          <span className="text-sm font-light">
            {t('footer.powered')}
          </span>
          <span className="text-sm font-semibold">
            Lokk
          </span>
        </div>
      </div>
    </div>
  );
};

export default Intro;